import PublicPage from "./PublicPage.jsx";
import { SUPPORT_EMAIL } from "./legalInfo.js";

const SECTIONS = [
  {
    title: "Getting started",
    items: [
      {
        q: "How do I scan a receipt?",
        a: "Sign in, go to the Scan tab, and either take a photo with your camera or choose a file (image, PDF, or Word doc) from your device. The AI reads the vendor, date, amount and category automatically — check them over and save. Assign it to a report (or leave it unassigned) using the report picker.",
      },
      {
        q: "What's the free scan?",
        a: "Every new account gets one real receipt scan, completely free, no card required. After that, you'll need to buy a credit pack to keep scanning.",
      },
      {
        q: "Do I need to install anything?",
        a: "No — it runs in your browser. On a phone, open the site and use \"Add to Home Screen\" to install it like an app.",
      },
    ],
  },
  {
    title: "Credits & billing",
    items: [
      {
        q: "How does pricing work?",
        a: "Pay-as-you-go only — no subscription. Buy a credit pack once, and it's spent one credit-chunk at a time as you scan receipts. Bigger packs cost less per scan.",
      },
      {
        q: "Do credits expire?",
        a: "No. Buy a pack once and use it at whatever pace suits your business.",
      },
      {
        q: "What if a scan fails?",
        a: "You're only charged for a successful scan. If the OCR call fails for any reason, nothing is deducted from your balance.",
      },
      {
        q: "Can I get a refund?",
        a: "See our Refund & Cancellation Policy — unused credits are refundable within 14 days of purchase.",
      },
    ],
  },
  {
    title: "Accounts",
    items: [
      {
        q: "How do I sign in? Is there a password?",
        a: "No password — enter your email and we send you a one-time 6-digit code. The first successful code for a new email address creates your account automatically.",
      },
      {
        q: "Can I give my accountant or a colleague shared access?",
        a: "Yes — invite them from Settings for read-only shared access: they can sign in, browse expenses, view receipt images, and download report PDFs, but can't scan, edit, or delete anything.",
      },
      {
        q: "Can I change my company/supplier names or mileage rate?",
        a: "Yes — go to the Settings tab (owner accounts only) to edit your company name and mileage reimbursement rate.",
      },
    ],
  },
  {
    title: "Privacy & data",
    items: [
      {
        q: "Is my receipt data private?",
        a: "Yes. Receipt images and expense data are only ever shown to your own account. See our Privacy Policy for full details on how data is handled.",
      },
      {
        q: "What happens to my data if I stop using the service?",
        a: "Your data stays in your account indefinitely (no forced deletion), but you can delete individual expenses at any time, or email us to request full account deletion.",
      },
    ],
  },
];

export default function HelpPage({ onNavigate, onGetStarted }) {
  return (
    <PublicPage title="Help & FAQ" onNavigate={onNavigate} onGetStarted={onGetStarted}>
      {SECTIONS.map((section) => (
        <section key={section.title} className="legal-section">
          <h2 className="landing-h2 legal-h2">{section.title}</h2>
          <div className="landing-faq-list">
            {section.items.map((item) => (
              <details key={item.q} className="card landing-faq-item">
                <summary className="landing-faq-q">{item.q}</summary>
                <p className="landing-trust-desc">{item.a}</p>
              </details>
            ))}
          </div>
        </section>
      ))}
      <p className="legal-p">
        Didn't find what you needed?{" "}
        <button className="link-btn" onClick={() => onNavigate("contact")}>
          Contact us
        </button>{" "}
        or email <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
      </p>
    </PublicPage>
  );
}
